import useConfirmAction from "v4/features/front/pennylane/components/PennylaneButton/hooks/useConfirmAction";
import usePennylaneState from "v4/features/front/pennylane/hooks/usePennylaneState";
import usePennylaneSync from "v4/features/front/pennylane/hooks/usePennylaneSync";
import { openPennylaneLink } from "v4/features/front/pennylane/pennylane.utils";

export default function usePennylaneButton(quote) {
    const { isActive, hasExternalRelation, hasLinkedInvoice, isLocked, lockReason, quoteUrl, invoiceUrl } = usePennylaneState(quote);
    const { sync, isLoading, error, clearError, retry } = usePennylaneSync(quote);

    const createDialog = useConfirmAction(sync, isLoading);
    const updateDialog = useConfirmAction(sync, isLoading);

    const handleAccessQuote = () => openPennylaneLink(quoteUrl);
    const handleAccessInvoice = () => openPennylaneLink(invoiceUrl);

    return {
        isActive,
        hasExternalRelation,
        hasLinkedInvoice,
        isLocked,
        lockReason,
        createDialog,
        updateDialog,
        handleAccessQuote,
        handleAccessInvoice,
        error,
        invoiceUrl,
        isLoading,
        clearError,
        retry,
    };
}
